import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { concat, Observable, of, Subject } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';

import { DefaultRequestParamsConstant } from '@app/core/_constant/index.constants';
import { LocationDetailsService } from '@app/core/locations/services/location-details.service';
import { LocationService } from '@app/core/locations/services/location.service';

@Component({
  selector: 'scan-location',
  templateUrl: './scan-location.component.html',
  styleUrls: ['./scan-location.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ScanLocationComponent implements OnInit {
  location$ :Observable<any[]>;
  locationLoading :boolean = false;
  locationInput$ :Subject<string> = new Subject<string>();

  constructor(
    private activeModal :NgbActiveModal,
    private locationSvc :LocationService,
    private locationDetailsSvc :LocationDetailsService,
  ) {}

  ngOnInit() {
    this.loadLocations();
  }

  private loadLocations() {
    this.location$ = concat(
      of([]), // default items
      this.locationInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.locationLoading = true)),
        switchMap((term) =>
          this.locationSvc
            .getAsync({
              keyword: term,
              per_page: DefaultRequestParamsConstant.limit,
              page: DefaultRequestParamsConstant.page,
              withoutStockLocations: true,
            })
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.locationLoading = false)),
              map((resp :any) => resp.data),
            ),
        ),
      ),
    );
  }

  public updateLocation(location) {
    this.locationDetailsSvc.set(location);
    this.activeModal.close(location.id);
  }

  close() {
    this.activeModal.dismiss();
  }
}
